import React, { useMemo, useState, useCallback } from "react";
import styles from "../../../CSS/sections/Testimonials.module.css";
import { ChevronLeft, ChevronRight } from "lucide-react";


const Testimonials = ({ content }) => {
  const { title, description, videos } = content;
  const [currentIndex, setCurrentIndex] = useState(0);

  const totalSlides = useMemo(() => videos.length, [videos.length]);

  const goTo = useCallback(
    (index) => {
      if (totalSlides === 0) return;
      const normalized = ((index % totalSlides) + totalSlides) % totalSlides; // wrap safely
      setCurrentIndex(normalized);
    },
    [totalSlides]
  );

  const handlePrev = useCallback(() => {
    goTo(currentIndex - 1);
  }, [currentIndex, goTo]);

  const handleNext = useCallback(() => {
    goTo(currentIndex + 1);
  }, [currentIndex, goTo]);

  return (
    <section className={`${styles.testimonialsSection} padding-y`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 text-center">
            <h2 className="heading2 mb-4">{title}</h2>
            <p className="mb-4">{description}</p>
          </div>
          <div
            className="col-12 d-flex"
            style={{ flexDirection: "column", gap: 30 }}
          >
            <div className={styles.slider}>
              <div
                className={styles.track}
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {videos.map((video, idx) => {
                  return (
                    <div
                      className={styles.slide}
                      key={idx}
                      aria-hidden={currentIndex !== idx}
                    >
                      <iframe
                        className={styles.iframe}
                        src={video.youtubeUrl}
                        title={`Testimonial video ${idx + 1}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={styles.navigation}>
              <button
                type="button"
                className={styles.navButton}
                onClick={handlePrev}
                aria-label="Previous testimonial"
              >
                <ChevronLeft size={20} />
              </button>

              <div
                className={styles.pagination}
                role="tablist"
                aria-label="Testimonials pagination"
              >
                {videos.map((_, idx) => {
                  const isActive = idx === currentIndex;
                  return (
                    <button
                      key={idx}
                      type="button"
                      className={`${styles.dot} ${isActive ? styles.dotActive : ""
                        }`}
                      onClick={() => goTo(idx)}
                      aria-label={`Go to slide ${idx + 1}`}
                      aria-current={isActive ? "true" : "false"}
                    />
                  );
                })}
              </div>

              <button
                type="button"
                className={styles.navButton}
                onClick={handleNext}
                aria-label="Next testimonial"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Testimonials;
